import { AnimationContext } from '../animationContext/AnimationContext'
import { useContext } from 'react'

/**
 * Helper hook for getting configuration for a motion 'layout' transition. E.g.,
 *
 *    const transition = useLayoutTransition()
 *    return <motion.div layout transition={transition}>
 */
export const useLayoutTransition = () => {
  const { animated, config } = useContext(AnimationContext)
  return animated ? config.layoutTransition : { type: false }
}
